import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import moment from "moment";
import { useUpdateRequestStatusMutation } from "src/services/RecordingRequestServices";
import { showToast } from "src/utils/showToaster";
import { object, string } from "yup";
import StatusChangeDialog from "./StatusChangeDialog";

type Props = {
  onClose: () => void;
  requestId: any;
};

export type StatusChangeDialogValues = {
  accessStartDate: string;
  accessEndDate: string;
};

const StatusChangeDialogWrapper = ({ onClose, requestId }: Props) => {
  const [updateStatus] = useUpdateRequestStatusMutation();
  // Form Initial Values
  const initialValues: StatusChangeDialogValues = {
    accessStartDate: requestId?.requestedStartDate,
    accessEndDate: requestId?.requestedEndDate,
  };

  // Validation Schema
  const validationSchema = object().shape({
    accessStartDate: string().required("Please enter start string"),
    accessEndDate: string().required("Please enter end date"),
  });

  // Handle Submit
  const handleSubmit = (
    values: StatusChangeDialogValues,
    { setSubmitting, resetForm }: FormikHelpers<StatusChangeDialogValues>
  ) => {
    const formattedValues = {
      status: "APPROVED",
      accessStartDate: values?.accessStartDate
        ? moment(values?.accessStartDate).format("yyyy-MM-DD")
        : "",
      accessEndDate: values?.accessEndDate
        ? moment(values?.accessEndDate).format("yyyy-MM-DD")
        : "",
    };

    updateStatus({ id: requestId?._id, body: formattedValues }).then(
      (res: any) => {
        if (res?.error) {
          showToast("error", res?.error?.data?.message);
        } else {
          if (res?.data?.status) {
            showToast("success", res?.data?.message);
            resetForm();
            onClose();
          } else {
            showToast("error", res?.data?.message);
          }
        }
        setSubmitting(false);
      }
    );
  };

  return (
    <Dialog open maxWidth="xs" fullWidth>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {(formikProps) => (
          <Form>
            <StatusChangeDialog formikProps={formikProps} onClose={onClose} />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default StatusChangeDialogWrapper;
